import React, { useState, useEffect } from 'react';
//import {useHistory} from 'react-router-dom'

import ReactLoading from 'react-loading';


import { withRouter } from "react-router-dom";


function LoadingToRedirect({history}) {
    const [count, setCount] = useState(10)
    useEffect(() => {
        const interval = setInterval(() => {
            setCount((currentCount) => --currentCount);
        }, 1000)
        count === 0 && history.push('/home/signin')

        return () => clearInterval(interval)

    }, [count, history])

    return (
        <div className="d-flex justify-content-center align-items-center">
            <ReactLoading type="bars" color="black" height={667} width={375} delay={5} />
        </div>

    )

}

export default  withRouter(LoadingToRedirect) ;

